document.addEventListener('DOMContentLoaded', function() {
  // Select the button text element
  const addToCartText = document.getElementById('dynamic-add-to-cart-text');
  if (!addToCartText) return;
  
  // Get the quantity input
  const quantityInput = document.querySelector('input[name="quantity"]');
  
  // Store the base text of the button to avoid string operations each time
  let baseButtonText = '';
  let lastKnownPrice = null;
  
  // Initialize base text once
  function initializeBaseText() {
    const textContent = addToCartText.textContent.trim();
    baseButtonText = textContent.split('-')[0].trim();
  }
  
  // Define quantity discount tiers - CUSTOMIZE THESE BASED ON YOUR SHOPIFY AUTOMATIC DISCOUNTS
  const quantityDiscounts = [
    { minQuantity: 6, discountPercent: 25 }, // 25% off for 6+ items
    { minQuantity: 3, discountPercent: 15 }  // 15% off for 3-5 items
  ];
  
  // Function to calculate the discount based on quantity
  function getDiscountMultiplier(quantity) {
    // Sort discounts from highest to lowest quantity requirement to ensure we get the best discount
    const sortedDiscounts = [...quantityDiscounts].sort((a, b) => b.minQuantity - a.minQuantity);
    
    // Find the applicable discount tier
    for (const tier of sortedDiscounts) {
      if (quantity >= tier.minQuantity) {
        return 1 - (tier.discountPercent / 100); // Convert percent to multiplier (e.g. 25% off = 0.75x)
      }
    }
    
    // No discount applicable
    return 1;
  }
  
  // Function to check if price needs to be updated
  function updateButtonPrice() {
    // Get the current quantity
    const quantity = parseInt(quantityInput?.value || 1);
    
    // Check for subscription selection
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    const subscriptionSelected = sellingPlanInput && sellingPlanInput.value;
    
    // Determine the base price
    const basePrice = subscriptionSelected ? 30.00 : 45.00;
    
    // Calculate original price (always based on $45 one-time price)
    const originalPrice = 45.00 * quantity;
    
    // Apply quantity discount
    const discountMultiplier = getDiscountMultiplier(quantity);
    
    // Calculate total with discount
    const totalPrice = basePrice * quantity * discountMultiplier;
    
    // Calculate price per serving (assuming 30 servings per unit)
    const pricePerServing = totalPrice / (30 * quantity);
    
    // Only update if the price has actually changed
    if (lastKnownPrice !== totalPrice) {
      lastKnownPrice = totalPrice;
      
      // Format the prices with 2 decimal places
      const formattedTotalPrice = '$' + totalPrice.toFixed(2);
      const formattedPricePerServing = '$' + pricePerServing.toFixed(2);
      const formattedOriginalPrice = '$' + originalPrice.toFixed(2);
      
      // Show strikethrough original price if there's a discount (subscription or quantity)
      const hasDiscount = subscriptionSelected || discountMultiplier < 1;
      
      // Keep add to cart text simple - just the text portion
      const buttonTextOnly = baseButtonText;
      
      if (hasDiscount) {
        // With discount - show both original and discounted price
        addToCartText.innerHTML = `
          <span class="add-to-cart-text-part">${buttonTextOnly}</span>
          <span class="price-container">
            <span class="original-price">${formattedOriginalPrice}</span>
            <span class="current-price">${formattedTotalPrice}</span>
            <span class="per-serving">${formattedPricePerServing} / serving</span>
          </span>
        `;
      } else {
        // No discount - just show current price
        addToCartText.innerHTML = `
          <span class="add-to-cart-text-part">${buttonTextOnly}</span>
          <span class="price-container">
            <span class="current-price">${formattedTotalPrice}</span>
            <span class="per-serving">${formattedPricePerServing} / serving</span>
          </span>
        `;
      }
    }
  }
  
  // Add class to button for better control of styles
  function setupButtonClasses() {
    const submitButton = document.querySelector('.product-form__submit');
    if (submitButton && !submitButton.classList.contains('yzn-style-button')) {
      submitButton.classList.add('yzn-style-button');
    }
  }
  
  // More efficient subscription detection function - run less frequently
  function checkForSubscriptionChanges() {
    // Force a thorough check
    updateButtonPrice();
    
    // Check again after a small delay to catch any delayed DOM updates
    setTimeout(updateButtonPrice, 50);
  }
  
  // Initialize the base text
  initializeBaseText();
  setupButtonClasses();
  
  // Add primary event listeners
  if (quantityInput) {
    quantityInput.addEventListener('change', updateButtonPrice);
    quantityInput.addEventListener('input', updateButtonPrice);
  }
  
  // Seal Subscriptions specific events
  document.addEventListener('sealsubs:option_selected', function() {
    updateButtonPrice();
  });
  
  // Add targeted click listeners for subscription options
  document.addEventListener('click', function(e) {
    // Only respond to clicks on subscription-related elements
    if (e.target.closest('.sealsubs-option') || 
        e.target.closest('.sealsubs-subscription-widget') ||
        e.target.closest('.sealsubs-radio-button')) {
      
      // Staggered checks to catch delayed DOM updates
      checkForSubscriptionChanges();
    }
  });
  
  // Run the initial update
  updateButtonPrice();
  
  // Add a polling check for subscription changes - run every 250ms
  // This is a backup to catch changes that might be missed by events
  const pollingInterval = setInterval(function() {
    if (document.visibilityState !== 'visible') return; // Only run when page is visible
    updateButtonPrice();
  }, 250);
  
  // Clean up interval when page is unloaded
  window.addEventListener('beforeunload', function() {
    clearInterval(pollingInterval);
  });
  
  // Handle window resize events to ensure layout remains correct
  window.addEventListener('resize', function() {
    updateButtonPrice();
  });
});